<section class="lms-overview" *ngIf="!loading && data" [attr.aria-label]="'dashboard.LmsOverview' | translate">
  <div class="lms-overview__head">
    <div>
      <div class="dash-card__title mb-0">{{ 'dashboard.LmsOverview' | translate }}</div>
      <div class="dash-card__sub mb-0">{{ 'dashboard.LmsOverviewSub' | translate: { days: data.activeWindowDays } }}</div>
    </div>
    <div class="lms-overview__links">
      <a routerLink="/courses" class="lms-overview__link">{{ 'dashboard.ManageCourses' | translate }}</a>
      <a routerLink="/courses/library" class="lms-overview__link">{{ 'nav.ContentLibrary' | translate }}</a>
    </div>
  </div>

  <div class="dash-kpis dash-kpis--4">
    <div class="dash-kpi">
      <div class="dash-kpi__head">
        <span class="dash-kpi__label">{{ 'dashboard.ActiveLearners' | translate }}</span>
        <span class="dash-kpi__icon dash-kpi__icon--blue"><i class="bi bi-lightning-charge"></i></span>
      </div>
      <div class="dash-kpi__value">{{ data.activeLearners | number }}</div>
      <div class="dash-kpi__foot"><span class="dash-kpi__caption">{{ 'dashboard.OfEnrolledLearners' | translate: { total: data.totalLearners } }}</span></div>
    </div>

    <div class="dash-kpi">
      <div class="dash-kpi__head">
        <span class="dash-kpi__label">{{ 'dashboard.CourseCompletions' | translate }}</span>
        <span class="dash-kpi__icon dash-kpi__icon--teal"><i class="bi bi-check2-circle"></i></span>
      </div>
      <div class="dash-kpi__value">{{ data.completionsTotal | number }}</div>
      <div class="dash-kpi__foot">
        <span class="dash-delta dash-delta--up" *ngIf="data.completionsInWindow"><i class="bi bi-arrow-up-right"></i><span dir="ltr">+{{ data.completionsInWindow }}</span></span>
        <span class="dash-kpi__caption">{{ 'dashboard.InLastDays' | translate: { days: data.activeWindowDays } }}</span>
      </div>
    </div>

    <div class="dash-kpi">
      <div class="dash-kpi__head">
        <span class="dash-kpi__label">{{ 'dashboard.CertificatesIssued' | translate }}</span>
        <span class="dash-kpi__icon dash-kpi__icon--amber"><i class="bi bi-award"></i></span>
      </div>
      <div class="dash-kpi__value">{{ data.certificatesIssued | number }}</div>
      <div class="dash-kpi__foot">
        <span class="dash-delta dash-delta--up" *ngIf="data.certificatesInWindow"><i class="bi bi-arrow-up-right"></i><span dir="ltr">+{{ data.certificatesInWindow }}</span></span>
        <span class="dash-kpi__caption">{{ 'dashboard.InLastDays' | translate: { days: data.activeWindowDays } }}</span>
      </div>
    </div>

    <div class="dash-kpi">
      <div class="dash-kpi__head">
        <span class="dash-kpi__label">{{ 'dashboard.CourseStorage' | translate }}</span>
        <span class="dash-kpi__icon dash-kpi__icon--violet"><i class="bi bi-hdd-stack"></i></span>
      </div>
      <div class="dash-kpi__value lms-overview__storage">{{ size(data.storage.usedBytes) }}</div>
      <div class="lms-overview__track" *ngIf="hasQuota" [class.is-warn]="data.storage.isNearLimit">
        <span [style.width.%]="data.storage.usedPercent"></span>
      </div>
      <div class="dash-kpi__foot">
        <span class="dash-kpi__caption">
          {{ hasQuota ? ('dashboard.OfQuota' | translate: { quota: size(data.storage.quotaBytes) }) : noStorageAllowance ? ('dashboard.NoStorageAllowance' | translate) : ('dashboard.UnlimitedStorage' | translate) }}
        </span>
      </div>
    </div>
  </div>

  <div class="dash-card lms-overview__top" *ngIf="data.topCourses.length">
    <div class="dash-card__title">{{ 'dashboard.TopCourses' | translate }}</div>
    <div class="dash-card__sub">{{ 'dashboard.TopCoursesSub' | translate: { published: data.publishedCourses, paths: data.publishedPaths } }}</div>
    <a class="dash-rank lms-overview__course" *ngFor="let c of data.topCourses; let i = index" [routerLink]="['/courses/builder', c.courseId]">
      <span class="dash-rank__no">{{ i + 1 }}</span>
      <span class="dash-rank__name" dir="auto">{{ c.title }}</span>
      <span class="dash-rank__val">{{ 'dashboard.LearnersShort' | translatePlural: { count: c.learners } }} · {{ c.completionRate | number: '1.0-0' }}%</span>
    </a>
  </div>
</section>
